import { render, staticRenderFns } from "./BookingHistory.vue?vue&type=template&id=e63d13c0"
import script from "./BookingHistory.vue?vue&type=script&lang=js"
export * from "./BookingHistory.vue?vue&type=script&lang=js"
import style0 from "./BookingHistory.vue?vue&type=style&index=0&id=e63d13c0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports